import { Autocomplete, Box, TextField } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { Task } from "../../interface";
import { useEffect, useState } from "react";

const users = [
    { label: "Juan Perez" },
    { label: "Maria A." },
    { label: "Luis Perez" },
];

const InfoHeader = ({task, ListOfUsers,  onChange}:{task:Task|undefined, ListOfUsers:any[], onChange:any}) => {

    return (
        <Box
            sx={{
                justifyContent: "center",
                width: "100%",
                ml: 2,
                mt: 2,
            }}
        >
            <Grid container spacing={2}>
                <Grid size={6}>
                    <TextField
                        id="advanced"
                        label="Avance"
                        value={`${task?.advance || "0"}`}
                        onChange={(e) => {
                            const value = e.target.value;
                            if (!isNaN(Number(value))) {
                                onChange(value, "advance");
                            }
                        }}
                        fullWidth
                        size="small"
                    />
                </Grid>
                <Grid size={6}>
                    <Autocomplete
                        fullWidth
                        disablePortal
                        size="small"
                        value={ListOfUsers?.find((user)=>user.id===task?.reporterUserId)?.label || ""}
                        options={ListOfUsers}
                        onChange={(event: any, newValue: any)=>onChange(newValue?.id, "reporterUserId")}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Reporta"
                                fullWidth
                            />
                        )}
                    />
                </Grid>
                <Grid size={6}>
                    <Autocomplete
                        fullWidth
                        disablePortal
                        size="small"
                        value={ListOfUsers?.find((user)=>user.id===task?.assignedUserId)?.label || ""}
                        options={ListOfUsers}
                        onChange={(event: any, newValue: any)=>onChange(newValue?.id, "assignedUserId")}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Asignado a"
                                fullWidth
                            />
                        )}
                    />
                </Grid>
                <Grid size={6}>
                    <Autocomplete
                        fullWidth
                        disablePortal
                        size="small"
                        value={ListOfUsers?.find((user)=>user.id===task?.approverUserId)?.label || ""}
                        options={ListOfUsers}
                        onChange={(event: any, newValue: any)=>onChange(newValue?.id, "approverUserId")}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Aprobador "
                                fullWidth
                            />
                        )}
                    />
                </Grid>
            </Grid>
        </Box>
    );
};

export default InfoHeader;
